module.exports = __webpack_public_path__ + "static/media/Phonecoverpage6.d969c2ce.png";